import type CalculationResultDto from "../../dto/calculations/CalculationResultDto";
import type LoadCaseResultDto from "../../dto/calculations/LoadCaseResultDto";
import type LoadCaseResultValueDto from "../../dto/calculations/LoadCaseResultValueDto";
import type MastResultDto from "../../dto/calculations/MastResultDto";
import type MaxLoadCaseValue from "./types/MaxLoadCaseValue";

const markGreatestLoadCaseValue = (lclCurrentCalculationResults: CalculationResultDto | undefined): CalculationResultDto | undefined => {
  if(!lclCurrentCalculationResults) return lclCurrentCalculationResults;
  const maxValuesPerMast = getMaxValues(lclCurrentCalculationResults);

  return {
    ...lclCurrentCalculationResults,
    mastResults: lclCurrentCalculationResults?.mastResults?.map((mr: MastResultDto) => {
      return {
        ...mr,
        loadCaseResults: mr.loadCaseResults?.map((lc: LoadCaseResultDto) => ({
          ...lc,
          loadCaseResultValues: lc.loadCaseResultValues.map((lcr: LoadCaseResultValueDto) => {
            if (!maxValuesPerMast[mr.mastNo]) {
              maxValuesPerMast[mr.mastNo] = {
                sk: 0,
                ft: 0,
                zt: 0,
                ut: 0,
                st: 0,
              };
            }

            const shouldValueNotBeBolded = shouldSlsOrUlsValueBeSkipped(
              lcr.abbreviation,
              lc.loadCase.slsUls,
            );

            if (
              !shouldValueNotBeBolded &&
              maxValuesPerMast[mr.mastNo][lcr.abbreviation] === lcr.value
            ) {
              return {...lcr, isMaxValue: true};
            }

            return lcr;
          }),
        })),
      };
    }),
  };
};

const getMaxValues = (
  lclCurrentCalculationResults: CalculationResultDto,
): Record<string, MaxLoadCaseValue> => {
  const maxValuesPerMast: Record<string, MaxLoadCaseValue> = {};

  lclCurrentCalculationResults?.mastResults?.forEach((mr: MastResultDto) => {
     mr.loadCaseResults.forEach((lc: LoadCaseResultDto) => {
       lc.loadCaseResultValues.forEach((lcr: LoadCaseResultValueDto) => {
        if (!maxValuesPerMast[mr.mastNo]) {
          maxValuesPerMast[mr.mastNo] = {
            sk: 0,
            ft: 0,
            zt: 0,
            ut: 0,
            st: 0,
          };
        }

        const shouldComparisonBeSkipped = shouldSlsOrUlsValueBeSkipped(
          lcr.abbreviation,
          lc.loadCase.slsUls,
        );
        const key = lcr.abbreviation as keyof MaxLoadCaseValue;

        if (
          !shouldComparisonBeSkipped &&
          Math.abs(maxValuesPerMast[mr.mastNo][key]) <
            Math.abs(Number(lcr.value))
        ) {
          if(lcr.value)
            maxValuesPerMast[mr.mastNo][key] = lcr.value;
        }
      });
    });
  });

  return maxValuesPerMast;
};

const shouldSlsOrUlsValueBeSkipped = (
  abbreviation: string,
  slsOrUls: string,
): boolean => {
  let shouldValueBeSkipped = false;

  if (
    slsOrUls === "ULS" &&
    (abbreviation === "zt" || abbreviation === "ut" || abbreviation === "ft")
  ) {
    shouldValueBeSkipped = true;
  }

  if (slsOrUls === "SLS" && (abbreviation === "sk" || abbreviation === "st")) {
    shouldValueBeSkipped = true;
  }

  return shouldValueBeSkipped;
};

export default markGreatestLoadCaseValue;
